import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import Typography from '../../library/typography/typography';

import styles from './product-swatch-description.scss';

function ProductSwatchDescription(props) {
  const { className = '', color, finish } = props;

  if (!finish && !color) {
    return null;
  }

  return (
    <div
      className={cn(
        styles['container'],
        `product-swatch-description ${className}`
      )}
    >
      <Typography className="product-swatch-description__label" tag="span">
        {finish ? 'Finish' : 'Color / Finish'}:{' '}
      </Typography>
      <Typography
        className={cn(styles['finish'], 'product-swatch-description__finish')}
        tag="span"
        weight="bold"
      >
        {finish || color}
      </Typography>
    </div>
  );
}

ProductSwatchDescription.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  finish: PropTypes.string
};
export default ProductSwatchDescription;
